import { useTranslation } from '@/lib/i18n';
import { Button, Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui';

export interface FundingDeleteModalProps {
  isOpen: boolean;
  title: string;
  isSubmitting: boolean;
  errorMessage?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const FundingDeleteModal = ({
  isOpen,
  title,
  isSubmitting,
  errorMessage,
  onConfirm,
  onCancel,
}: FundingDeleteModalProps) => {
  const { t } = useTranslation('funding');

  return (
    <Dialog open={isOpen} onOpenChange={(o) => { if (!o && !isSubmitting) onCancel(); }}>
      <DialogContent data-testid="funding-delete-modal" className="max-w-md">
        <DialogTitle>{t('funding.detail.deleteDialog.title')}</DialogTitle>
        <DialogDescription>
          {t('funding.detail.deleteDialog.subject', { title })}
        </DialogDescription>

        <p
          className="rounded-md p-3 text-sm"
          style={{
            background: 'var(--status-warn-bg)',
            color: 'var(--status-warn-fg)',
          }}
        >
          {t('funding.detail.deleteDialog.description')}
        </p>

        {errorMessage ? (
          <p
            role="alert"
            aria-live="polite"
            className="rounded-md p-2 text-sm"
            style={{
              background: 'var(--status-danger-bg)',
              color: 'var(--status-danger-fg)',
            }}
          >
            {errorMessage}
          </p>
        ) : null}

        <div className="mt-2 flex justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            size="md"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            {t('funding.detail.deleteDialog.cancel')}
          </Button>
          <Button
            type="button"
            variant="danger"
            size="md"
            disabled={isSubmitting}
            onClick={onConfirm}
          >
            {isSubmitting
              ? t('funding.detail.deleteDialog.deleting')
              : t('funding.detail.deleteDialog.confirm')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
